import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { ScheduleAction } from '@cbridge-packages/schedule';
import { RouterAction } from '@cbridge-packages/routing';
import { generateScheduleProfileRoute } from '@cbridge-packages/routing-client-admin';

export const toggleViewScheduleSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(ScheduleAction.create.done),
    delay(100),
    map(({ result }) => RouterAction.replace([generateScheduleProfileRoute(result.scheduleId)])),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(ScheduleAction.update.done),
    map(({ params }) => RouterAction.replace([generateScheduleProfileRoute(params.scheduleId)])),
  ),
);
